// Max custom design preview dimension passed down to MMS Images to limit file size and optimize load time
export const customPreviewMaxDimension = 400;
export const mmsImagesProduction =
  'https://mms-images.out.customink.com/mms/images/catalog';
export const mmsImagesStaging =
  'https://mms-images.staging.customink.com/mms/images/catalog';
